import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { createShareLink } from "../repo/itineraryRepo";
import { getItineraryTable } from "../repo/itineraryTableRepo";
import { outputOperationErrorMessage } from "../service/itineraryOutputService";

/** 独立表格数据库读取与分享创建；离页后隔离旧异步结果。 */
export function useItineraryTable(itineraryId: string) {
  const query = useQuery({
    queryKey: ["itinerary", "table", itineraryId],
    queryFn: ({ signal }) => getItineraryTable(itineraryId, signal),
    enabled: Boolean(itineraryId), retry: false, staleTime: 0, refetchOnMount: "always",
    refetchOnWindowFocus: false,
  });
  const operation = useRef(0);
  const busy = useRef(false);
  const [sharing, setSharing] = useState(false);
  const [shareUrl, setShareUrl] = useState("");
  const [error, setError] = useState("");
  useEffect(() => () => { operation.current += 1; }, []);
  const share = async () => {
    if (busy.current || !query.data || query.isFetching || query.isError) return;
    busy.current = true;
    setSharing(true);
    setError("");
    const current = ++operation.current;
    try {
      const result = await createShareLink(itineraryId, "table");
      if (operation.current === current) setShareUrl(new URL(result.url, window.location.origin).toString());
    } catch (cause) {
      if (operation.current === current) setError(outputOperationErrorMessage("share", cause));
    } finally {
      if (operation.current === current) { busy.current = false; setSharing(false); }
    }
  };
  return { query, share, sharing, shareUrl, error, closeShare: () => setShareUrl("") };
}
